import { Config } from 'effect';

import { ConfigKey } from './keys';

export const DEFAULT_TIMEZONE = 'Europe/Prague';

/**
 * The shell may override the zone through its agnostic ConfigProvider; the
 * existing rcprofi behavior stays Prague when that value is absent.
 */
export const TimezoneConfig = Config.withDefault(
  Config.NonEmptyString(ConfigKey.Timezone),
  DEFAULT_TIMEZONE
);
